/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckQuestionSampleImage } from './PaxCheckQuestionSampleImage';
import {
    PaxCheckQuestionSampleImageFromJSON,
    PaxCheckQuestionSampleImageFromJSONTyped,
    PaxCheckQuestionSampleImageToJSON,
    PaxCheckQuestionSampleImageToJSONTyped,
} from './PaxCheckQuestionSampleImage';
import type { PaxCheckQuestionTitle } from './PaxCheckQuestionTitle';
import {
    PaxCheckQuestionTitleFromJSON,
    PaxCheckQuestionTitleFromJSONTyped,
    PaxCheckQuestionTitleToJSON,
    PaxCheckQuestionTitleToJSONTyped,
} from './PaxCheckQuestionTitle';
import type { PaxCheckOption } from './PaxCheckOption';
import {
    PaxCheckOptionFromJSON,
    PaxCheckOptionFromJSONTyped,
    PaxCheckOptionToJSON,
    PaxCheckOptionToJSONTyped,
} from './PaxCheckOption';

/**
 * A question with options to choose from, requires single answer (option id)
 * @export
 * @interface PaxCheckPickFromListQuestion
 */
export interface PaxCheckPickFromListQuestion {
    /**
     * Question id
     * @type {string}
     * @memberof PaxCheckPickFromListQuestion
     */
    id: string;
    /**
     * Whether question is relevant for this passenger, according to current answers to all questions
     * @type {boolean}
     * @memberof PaxCheckPickFromListQuestion
     */
    isRelevant: boolean;
    /**
     * Question answer (Option id), if was provided
     * @type {string}
     * @memberof PaxCheckPickFromListQuestion
     */
    answer?: string | null;
    /**
     * Options to choose from
     * @type {Array<PaxCheckOption>}
     * @memberof PaxCheckPickFromListQuestion
     */
    options: Array<PaxCheckOption>;
    /**
     * 
     * @type {PaxCheckQuestionTitle}
     * @memberof PaxCheckPickFromListQuestion
     */
    questionTitle: PaxCheckQuestionTitle;
    /**
     * 
     * @type {PaxCheckQuestionSampleImage}
     * @memberof PaxCheckPickFromListQuestion
     */
    sampleImage?: PaxCheckQuestionSampleImage;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckPickFromListQuestion
     */
    defaultValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckPickFromListQuestion
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckPickFromListQuestion interface.
 */
export function instanceOfPaxCheckPickFromListQuestion(value: object): value is PaxCheckPickFromListQuestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('isRelevant' in value) || value['isRelevant'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('questionTitle' in value) || value['questionTitle'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckPickFromListQuestionFromJSON(json: any): PaxCheckPickFromListQuestion {
    return PaxCheckPickFromListQuestionFromJSONTyped(json, false);
}

export function PaxCheckPickFromListQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckPickFromListQuestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isRelevant': json['is_relevant'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'options': ((json['options'] as Array<any>).map(PaxCheckOptionFromJSON)),
        'questionTitle': PaxCheckQuestionTitleFromJSON(json['question_title']),
        'sampleImage': json['sample_image'] == null ? undefined : PaxCheckQuestionSampleImageFromJSON(json['sample_image']),
        'defaultValue': json['default_value'] == null ? undefined : json['default_value'],
        'type': json['type'],
    };
}

export function PaxCheckPickFromListQuestionToJSON(json: any): PaxCheckPickFromListQuestion {
    return PaxCheckPickFromListQuestionToJSONTyped(json, false);
}

export function PaxCheckPickFromListQuestionToJSONTyped(value?: PaxCheckPickFromListQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'is_relevant': value['isRelevant'],
        'answer': value['answer'],
        'options': ((value['options'] as Array<any>).map(PaxCheckOptionToJSON)),
        'question_title': PaxCheckQuestionTitleToJSON(value['questionTitle']),
        'sample_image': PaxCheckQuestionSampleImageToJSON(value['sampleImage']),
        'default_value': value['defaultValue'],
        'type': value['type'],
    };
}

